<template>
  <div>
    <Carousel/>
    <b-container fluid class="home-page">
      <h2>Aktuelle Beiträge</h2>
      <b-row class="justify-content-center">
        <NewsCards
          v-for="newsElement in news"
          :key="newsElement.id"
          :title="newsElement.title"
          :text="newsElement.text"
          :link="newsElement.link"
          :image="newsElement.image"/>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel.vue';
import NewsCards from '@/components/NewsCards.vue';
import client from 'api-client';

export default {
  name: 'home',
  components: {
    NewsCards,
    Carousel,
  },
  data() {
    return {
      loading: true,
      news: {},
      error: false,
    };
  },
  created() {
    client
      .fetchNewsList()
      .then(news => this.setNews(news))
      .catch((e) => {
        console.error(e);
        this.error = true;
      });
  },
  methods: {
    setNews(news) {
      this.news = news;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
  .home-page{
    margin-top: 50px;
    margin-bottom: 50px;
    min-height: calc(40vh - 226px);
  }
</style>
